import { TSuggestResponse_1 } from 'shared/repositories/geo-suggest/v2/suggest';
import { EGeoSuggestStatus } from 'shared/services/geoSuggest';

export const prepareGeoSuggest = (response: TSuggestResponse_1) => {
  return {
    data: response.data,
    message: null,
    status: EGeoSuggestStatus.Success,
  };
};
